// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__x2RPb","noPadding":"Accordion_noPadding__9zLCU","item":"Accordion_item__amQtc"};